import Joi, {SchemaLikeWithoutArray} from 'joi';
import {json} from "react-router";

export const LicenseItemSchema = Joi.object().keys({
  name: Joi.string(),
  value: Joi.string(),
});

export const PricingInfoItemSchema = Joi.object().keys({
  id: Joi.string(),
  description: Joi.string(),
  billing_cycle: Joi.string(),
  currency: Joi.string(),
  price: Joi.number(),
});

export const PlanSchema = Joi.object().keys({
  name: Joi.string(),
  description: Joi.string(),
  status: Joi.number(),
  product: Joi.string(),
  remote_ref_id: Joi.string(),
  remote_ref_system_id: Joi.string(),
  kaltura_analytic_ref: Joi.string(),
  product_family: Joi.string(),
  license_items: Joi.array().items(LicenseItemSchema),
  pricing_info: Joi.array().items(PricingInfoItemSchema),
  message: Joi.string(),
  _id: Joi.string(),
  __v: Joi.number(),
});

export const PackageAddonItemSchema = Joi.object().keys({
  controller: Joi.string(),
  groupControllerType: Joi.string(),
  headline: Joi.string(),
  icon: Joi.string(),
  name: Joi.string(),
  position: Joi.string(),
});

export const PackageSchema = Joi.object().keys({
  block_without_dunning: Joi.bool(),
  what_does_it_include: Joi.string(),
  monthly_headline: Joi.string(),
  annually_headline: Joi.string(),
  checkout_cta_text: Joi.string(),
  getStartedText: Joi.string(),
  summary_text: Joi.string(),
  created_at: Joi.string(),
  currency_code: Joi.string(),
  description: Joi.string(),
  excludePromotionalCredit: Joi.bool(),
  partner_config: Joi.object().keys({}).unknown(true),
  partner_register_config: Joi.object().keys({}).unknown(true),
  leading_plan: Joi.object().keys({}).unknown(true),
  monthly_addons: Joi.object().keys({}).unknown(true),
  name: Joi.string(),
  promotional_credit: Joi.number(),
  secureAmount: Joi.number(),
  status: Joi.number(),
  type: Joi.string(),
  updated_at: Joi.string(),
  yearly_addons: Joi.object().keys({}).unknown(true),
  getting_started_media_url: Joi.string(),
  create_account_media_url: Joi.string(),
  marketing_info: Joi.object().keys({}).unknown(true),
  department_list: Joi.object().keys({}).unknown(true),
  company_size_list: Joi.object().keys({}).unknown(true),
  custom_data: Joi.object().keys({}).unknown(true),
  __v: Joi.number(),
  _id: Joi.string(),
  message: Joi.string(),
});

export const CatalogItemSchema = Joi.object().keys({
  message: Joi.string(),
  package: Joi.array().items(PackageSchema),
  charge: Joi.array().items(PlanSchema),
  addon: Joi.array().items(PlanSchema),
  plan: Joi.array().items(PlanSchema),
});

export const CatalogItemsSchema = Joi.object().pattern(
  Joi.string(),
  CatalogItemSchema,
);

export const LocationCloneStateSchema = Joi.object().keys({
  product: Joi.alternatives(PackageSchema, PlanSchema),
});
